import { Alert, AlertTitle, Typography, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { ReactNode } from "react";

interface AgentAlertProps {
  severity?: "error" | "warning" | "info" | "success";
  title: string;
  description?: string | ReactNode;
  dismissable?: boolean;
  onDismiss?: () => void;
  action?: ReactNode;
}

export default ({
  severity = "info",
  title,
  description,
  dismissable = false,
  onDismiss,
  action,
}: AgentAlertProps) => {
  const alertAction =
    action ??
    (dismissable && onDismiss ? (
      <IconButton
        aria-label="close"
        color="inherit"
        size="small"
        onClick={onDismiss}
      >
        <Close fontSize="inherit" />
      </IconButton>
    ) : null);

  return (
    <Alert
      severity={severity}
      action={alertAction}
      sx={{ alignItems: "center" }}
    >
      <AlertTitle sx={{ mb: 0 }}>{title}</AlertTitle>
      {description &&
        (typeof description === "string" ? (
          <Typography variant="body">{description}</Typography>
        ) : (
          <Typography variant="body" component="div">
            {description}
          </Typography>
        ))}
    </Alert>
  );
};
